import React from 'react'

import { DistributiveOmit } from '@mui/types'
import { SidebarNavigationTab } from '@app/pages/Dashboard/SideBar/components/SidebarNavTab/styled'

interface SidebarNavTabProps<C extends React.ElementType = 'div'> {
	children?: React.ReactNode
	checked?: boolean
	component?: C
	sx?: object
}

type SidebarNavTabPropsOverride<C extends React.ElementType = 'div'> =
	SidebarNavTabProps<C> &
		DistributiveOmit<
			React.ComponentPropsWithRef<C>,
			keyof SidebarNavTabProps<C>
		>

const SidebarNavTab = <C extends React.ElementType = 'div'>(
	props: SidebarNavTabPropsOverride<C>
): JSX.Element => {
	return (
		<SidebarNavigationTab {...props}>{props.children}</SidebarNavigationTab>
	)
}

export default SidebarNavTab
